import { focusExamTab } from '../../helpers/helpers';
import { Button, Flex, Text, View } from '@smarterservices/smarter-ui';

const SessionAlreadyActive = () => {
  return (
    <Flex
      direction="column"
      justifyItems="center"
      alignItems="center"
      height="100vh"
      width="100%"
      padding="large"
    >
      <View
        as="div"
        width="75%"
        maxWidth="500px"
        padding="x-large"
        shadow="resting"
        borderRadius="medium"
        background="primary"
      >
        <Flex direction="column" gap="large" alignItems="center" textAlign="center">
          <Text size="x-large" weight="bold" color="primary">
            Session Already Active
          </Text>

          <Text size="medium" lineHeight="default">
            You have an active session on another tab. Please complete the other session before opening a new one. Otherwise, you can end the other session and start a new one.
          </Text>

          <Flex direction="column" gap="medium" width="100%">
            <Button
              color="primary"
              size="medium"
              onClick={focusExamTab}
              width="100%"
            >
              View Active Session
            </Button>
          </Flex>
        </Flex>
      </View>
    </Flex>
  );
};

export default SessionAlreadyActive;